import { NumberParam, useQueryParam } from 'use-query-params';
import { NumberInput } from '../../../../components/shared/input/Input';
import { QueryParamNames } from '../../enums/QueryParamNames';

const MAX_TIER = parseInt(import.meta.env.VITE_MAX_TIER);

export default function RatingFilter() {
    const [minRating, setMinRating] = useQueryParam(QueryParamNames.MIN_RATING, NumberParam);
    const [maxRating, setMaxRating] = useQueryParam(QueryParamNames.MAX_RATING, NumberParam);

    return (
        <div className='col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-2'>
            <p>Tier:</p>
            <div className='flex items-center'>
                <NumberInput min='1' max={MAX_TIER} value={minRating ?? null} onChange={setMinRating} />
                <p className='m-0 mx-2'>to</p>
                <NumberInput min='1' max={MAX_TIER} value={maxRating ?? null} onChange={setMaxRating} />
            </div>
        </div>
    );
}
